export default __webpack_public_path__ + "static/media/gift-payment-failure.a8a4a914.webp";